import React from 'react'
import { Robot as Icon } from 'react-bootstrap-icons'
import { OverlayTrigger, Popover } from 'react-bootstrap'
import hooks from '../../../hooks'

const AbsentIndicator = ({
    course = {},
    size = 20,
    userId,
}) => {
    const { id } = hooks.useCurrentUser();
    if (!course.autoEnrolled) {
        return null
    }

    return (
        <OverlayTrigger
            trigger={['click', 'hover']}
            placement='auto'
            rootClose
            overlay={
                <Popover>
                    <Popover.Content >
                        <strong>{userId === id ? 'You' : 'They'} were auto-enrolled for this experience.</strong>
                    </Popover.Content>
                </Popover>
            }
        >
            <div
                style={{
                    cursor: 'pointer',
                    padding: '12px',
                }}
            >
                <Icon size={size} />
            </div>
        </OverlayTrigger>
    )
}

export default AbsentIndicator